export default __webpack_public_path__ + "static/media/javierGrave.c9238fe7.jpg";